import { BookingScheduleDay } from "@/lib/types/schedule-types";
import {
  IGuestRequestQuote,
  IProfile,
  RequestEstimatePayload,
  RequestEstimateResponse,
} from "~/types/api-types";

import { ApiError } from "./api-error";

export const guestRequestQuote = async ({
  accessToken,
  locale,
  payload,
}: {
  accessToken: string | undefined;
  locale: string | undefined;
  payment_option: string | undefined;
  payload: {
    host_sso_id: string;
    guest_sso_id: string;
    sales_tax_disable: boolean;
    type: string;
    payment_option?: string;
    enforce_minimum_hours?: boolean;
    guest_fee_test_group?: string;
    items: {
      type: string;
      info: {
        host_id: string;
        guest_id: string;
        schedule: BookingScheduleDay[];
        rate: number;
        duration_type: string;
        listing_id: string;
        space_id: string;
        prepare_only: boolean;
        ga_client_id: IProfile["ga_client_id"];
        number_of_guests?: number;
        entitlement_external_id?: string;
      };
    }[];
  };
}): Promise<IGuestRequestQuote> => {
  const response = await fetch(
    `/v1/contracts/request/guest/quote?preferred_locale=${locale || "en-US"}`,
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        // If the user is logged out, it's fine to send up `Bearer undefined`
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new ApiError(
      errorData.body?.body?.message ||
        errorData.body?.error ||
        "Failed to get pricing",
      response.status,
      errorData,
    );
  }

  const data = (await response.json()) as IGuestRequestQuote;
  return data;
};

export const guestRequestEstimate = async (
  payload: RequestEstimatePayload,
): Promise<RequestEstimateResponse> => {
  const response = await fetch(`/v1/contracts/prices/estimate`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new ApiError(
      errorData.body?.body?.message ||
        errorData.body?.error ||
        "Failed to get estimate",
      response.status,
      errorData,
    );
  }

  const data = (await response.json()) as RequestEstimateResponse;
  return data;
};
